import { Link } from 'react-router';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/shadcn-ui/card';
import type { Period } from '@/entities/types';
import { useReportQueryError } from '@/hooks/useReportQueryError';
import { toFullDayDateString } from '@/utils/datetime';
import { usePlanForPeriod } from '@/queries/plan';
import { GoalsList } from '../GoalsList';

interface ContextCardProps {
  title: string;
  subtitle: string;
  period: Period;
  startAtLocal: string;
}

export function ContextCard({
  title,
  subtitle,
  period,
  startAtLocal,
}: ContextCardProps) {
  const { data: plan, error: planError } = usePlanForPeriod(
    period,
    startAtLocal,
  );

  useReportQueryError(planError, 'ContextCard');

  if (planError) {
    return <div>Error loading plan</div>;
  }
  if (!plan) {
    return null;
  }

  const planPath = `/${period}/${toFullDayDateString(new Date(startAtLocal))}`;

  return (
    <Card className="gap-5 shadow-xs">
        <CardHeader>
          <Link to={planPath}>
            <CardTitle className="hover:underline">{title}</CardTitle>
          </Link>
          <CardDescription className="font-light">{subtitle}</CardDescription>
        </CardHeader>
      <CardContent>
        <GoalsList
          planId={plan.id}
          period={period}
          startAtLocal={startAtLocal}
        />
      </CardContent>
    </Card>
  );
}
